<template>
  <div class="ship-popup">
    <div class="cesium-popup-header flex justify-between align-center">
      <span>船只信息</span>
      <ElButton circle size="small" @click="props.close">X</ElButton>
    </div>
    <table v-if="properties">
      <tbody>
        <tr v-for="item in tableData" :key="item.key">
          <td class="text-green-800">{{ item.key }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ElButton } from 'element-plus'

const props = defineProps<{
  properties: any
  close(): void
}>()
const properties = computed(() => {
  return props.properties
})

const tableData = computed(() => {
  return [
    {
      key: '船名',
      value: properties.value.name,
    },
    {
      key: 'MMSI',
      value: properties.value.mmsi,
    },
  ].filter((el) => el.value != undefined && el.value !== '-')
})
</script>

<style scoped>
.ship-popup {
  min-width: 240px;
  background-color: white;
  border-radius: 4px;
  padding: 8px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
td {
  padding: 4px 8px;
  font-size: 14px;
}
.cesium-popup-header {
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
}
</style>
